import {Injectable} from '@angular/core';
import {Action} from '@ngrx/store';

@Injectable({providedIn: 'root'})
export class LocalStorageActionService {
  private _actions: any[] = [];
  private _isLoaded = false;
  private _key = '__financeview_events_storage__';

  constructor() {
  }

  get actions() {
    if (!this._isLoaded) {
      this.load();
    }
    return this._actions;
  }

  storeExists() {
    const item = localStorage.getItem(this._key);
    return (item != null);
  }

  get isLoaded() {
    return this._isLoaded;
  }

  load() {
    const data = localStorage.getItem(this._key);
    if (data != null) {
      this._actions = JSON.parse(data);
    }
    this._isLoaded = true;
  }

  saveAction(action: Action) {
    console.log('SAVING STATE')
    if (!this._isLoaded) {
      this.load();
    }
    this.actions.push(action);
    localStorage.setItem(this._key, JSON.stringify(this.actions));
  }
}
